var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJoft3Lengeh1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 66 30",
    style: {
      enableBackground: "new 0 0 66 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M59,15.2h-6.7c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5H59c0.3,0,0.5,0.2,0.5,0.5S59.3,15.2,59,15.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "52.7,17.4 52.7,12 49.7,14.7  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9,15.2h-7.4c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h7.4c0.3,0,0.5,0.2,0.5,0.5S37.2,15.2,36.9,15.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2,18.6c-0.3,0-0.5-0.2-0.5-0.5v-6.7c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v6.7C33.7,18.3,33.5,18.6,33.2,18.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9,15.2H7.5C7.2,15.2,7,15,7,14.7s0.2-0.5,0.5-0.5h7.4c0.3,0,0.5,0.2,0.5,0.5S15.2,15.2,14.9,15.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2,18.6c-0.3,0-0.5-0.2-0.5-0.5v-6.7c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v6.7C11.7,18.3,11.5,18.6,11.2,18.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66,30H0V0h66V30z M1,29h64V1H1V29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3,30c-0.3,0-0.5-0.2-0.5-0.5V0.8c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v28.7C44.8,29.8,44.6,30,44.3,30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,30c-0.3,0-0.5-0.2-0.5-0.5V0.8c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v28.7C22.5,29.8,22.3,30,22,30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5,24.6h-13V5.7h13V24.6z M49.5,23.6h11v-17h-11V23.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5,24.6h-13V5.7h13V24.6z M5.5,23.6h11v-17h-11V23.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,26.4H23c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h21c0.3,0,0.5,0.2,0.5,0.5S44.3,26.4,44,26.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,4.9H23c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5h21c0.3,0,0.5,0.2,0.5,0.5C44.5,4.6,44.3,4.9,44,4.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoft3Lengeh1);
export default __webpack_public_path__ + "static/media/joft_3_lengeh_1.3f04ec101a1df20a424bff38f4a9a4d8.svg";
export { ForwardRef as ReactComponent };